import Client from '../axiosClient'
const resource = '/qa';
const resourceInit = '/qa_initialize';
const resourceUpdateStatus = '/qa_change_status';

export default {
  // init() {
  //   return Client.get(`${resourceInit}`);
  // },



  // get(payload) {
  //   if(payload) {
  //     let dashPartnerId = payload['dashPartnerId'] != undefined ? payload['dashPartnerId'] : "0";
  //     return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}&dashPartnerId=${dashPartnerId}`);
  //   }
  //   return Client.get(`${resource}`);
  // },

  init(payload) {
    //return Client.get(`${resourceInit}`);
    let filterParam='';
    if(payload) {
      let filterParam = 'requestFrom='+payload['requestFrom'];
      let dashPartnerUserId = payload['dashPartnerUserId'] != undefined ? payload['dashPartnerUserId'] : "0";
      let dashboardRoleId = payload['dashboardRoleId'] != undefined ? payload['dashboardRoleId'] : "0";
      let dashPartnerId = payload['dashPartnerId'] != undefined ? payload['dashPartnerId'] : "0";
      this.filterParam=filterParam+`&page=${payload['pageNo']}&pageLength=${payload['pageLength']}&dashPartnerUserId=${payload['dashPartnerUserId']}&dashboardRoleId=${payload['dashboardRoleId']}&dashPartnerId=${payload['dashPartnerId']}`;
      // this.filterParam=filterParam+`&page=${payload['pageNo']}&pageLength=${payload['pageLength']}&dashboardPartnerId=${dashboardPartnerId}&dashboardRoleId=${payload['dashboardRoleId']}&authUserRoleId=${payload['authUserRoleId']}&getAuthUserId=${payload['getAuthUserId']}`;
      return Client.get(`${resourceInit}?${this.filterParam}`);
    }
    return Client.get(`${resourceInit}`);
  },

  get() {
    return Client.get(`${resource}`);
  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },
  updateStatus(payload) {
    return Client.post(`${resourceUpdateStatus}`, payload);
  },

  /*update(payload, id) {
    return Client.courierAxios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return Client.courierAxios.delete(`${resource}/${id}`)
  },*/

  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/events/qaRepository.js